<template>
  <div>
    <!-- page wrapper start -->
    <div class="pg-wrapper" v-if="loaded">
      <app-header>
        <div class="title-bar" slot="header-foot">
          <button @click="goBack()" class="button is-flex nav-back">
            <img src="@/assets/img/icon-nav-arrow-left.svg" alt="Go Back" />
          </button>
          <h1 class="title has-text-black">Nearby Stores</h1>
        </div>
      </app-header>

      <main class="content-wrapper relative">
        <div class="column flex-grow-0 is-hidden-tablet has-background-white">
          <ul class="columns is-multiline tabs">
            <li class="column is-12 is-active">
              <a class="has-text-centered is-block ph0">Map</a>
            </li>
            <li class="column is-12 is-hidden-mobile">
              <a class="has-text-centered is-block ph0">List</a>
            </li>
          </ul>
        </div>
        <!-- store map tab -->
        <div class="map-tab tab-content">
          <!-- Section: Location Map -->
          <section class="map-section">
             <div class="map_canvas" v-if="locationNearBy.length < 1">
                <p class="mt-5 pt-5 text-center v-center">Sorry no store available.</p>
             </div>
            <div class="map_canvas" v-if="activeLocation && activeLocation.address && activeLocation.address.latitude && activeLocation.address.longitude">
              <gmap-map
                :center="{lat:parseFloat(activeLocation.address.latitude), lng:parseFloat(activeLocation.address.longitude)}"
                :zoom="16"
                map-type-id="terrain"
                style="width: 100%; height: 100%"
              >
                <gmap-marker
                  :key="index"
                  v-for="(m, index) in markers"
                  :position="m.position"
                  :clickable="true"
                  :draggable="true"
                  @click="center=m.position"
                ></gmap-marker>
              </gmap-map>
            </div>
          </section>

          <!-- section: Search Results List -->
          <section class="location-search-results ">
            <div class="mt0 ml0">
              <div class="results-col has-background-lightgrey is-paddingless is-4-tablet is-4-desktop is-3-widescreen store-locations-sidebar -has-background-white">
                 <div
                  v-for="(item, ind) in locationNearBy"
                  :class="( item.id == activeLocation.id ? 'is-active ' : '')+'result-item location-info'"
                  :key="ind"
                  @click="switchStore(item)"
                >
                  <h3 class="store-locality">
                    {{item.display_name}}
                    <span class="store-distance" v-if="item.distance">{{ item.distance }} km</span>
                  </h3>
                  <p
                    class="address"
                  >{{item.address ? item.address.formatted_address : '' }}</p>
                  <p class="store-status">
                    <span :class="item.currently_open ? 'has-text-green' : 'has-text-danger'">{{item.currently_open ? 'Open':'Closed'}} now </span>
                    • {{ getTodayOpenCloseTime(item) }}
                  </p>
                  <a href="#" @click.prevent="viewStore(item)" class="button bg-secondary text-white hover-opacity-7 is-medium mt20 is-hidden-tablet is-full-width is-size-15" >View Store</a>
            
                </div>
              </div>
            </div>
          </section>

          <!-- section: selected Location -->
          <section class="selected-location" v-if="activeLocation.id">
            <div class="store-item mb0">
              <div class="store-logo">
                <img v-if="getStorefeaturedImage(activeLocation.images)" class="store-img" :src="getStorefeaturedImage(activeLocation.images)" :alt="activeLocation.display_name">
              </div>
              <div class="store-detail">
                <div class="store-name has-text-black has-text-weight-semibold is-uppercase is-flex justify-content-between align-items-center" >
                  <p class="text-dark has-text-black">{{activeLocation.display_name}}</p>
                  <div class="distance has-text-black text-dark" v-if="activeLocation.distance"></div>
                </div>
                <div
                  class="store-address has-text-black text-dark"
                >{{activeLocation.address_line_1}} {{activeLocation.address_line_2 ? ', ' + activeLocation.address_line_2:''}}</div>
                <div class="store-timings is-flex">
                  <span :class="activeLocation.currently_open ? 'status has-text-green' : 'has-text-danger status' ">{{activeLocation.currently_open ? 'Open' : 'Closed' }} Now&nbsp;•&nbsp; </span>
                  <span class="time has-text-black">{{ getTodayOpenCloseTime(activeLocation) }}</span>
                </div>
              </div>
            </div>
            <a @click.prevent="viewStore(activeLocation)" class="button bg-secondary text-white hover-opacity-7 is-large is-full-width is-size-15">View Store</a>
          </section>
        </div>

        <!-- store list tab -->
        <div class="store-list-view tab-content is-hidden is-hidden-mobile">
          <div class="container">
            <div class="stores-list">
              <div class="store-item"
                v-for="(item, ind) in locationNearBy"
                :key="'lowerdevice_'+ind"
                @click="switchStore(item)"
                :class="( item.id == activeLocation.id ?'is-active':'is-closed')+' store-item '"
              >
                <div class="store-logo">
                  <img v-if="getStorefeaturedImage(item.images)" class="store-img" :src="getStorefeaturedImage(item.images)" :alt="activeLocation.display_name">
                </div>
                <div class="store-detail">
                  <div
                    class="store-name has-text-black has-text-weight-semibold is-uppercase is-flex justify-content-between align-items-center"
                  >
                    <p class="has-text-black">{{item.display_name}}</p>
                    <div class="distance has-text-black">1.2 km</div>
                  </div>
                  <div class="store-address has-text-black mb5">{{ item.address_line_1 }}</div>
                  <div class="store-timings is-flex">
                    <span :class="item.currently_open ? 'status has-text-green' : 'status has-text-danger'">{{ item.currently_open  ? "Open Now" : "Closed Now" }}•&nbsp;</span>
                    <span class="time has-text-black">{{ getTodayOpenCloseTime(item) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import { isEmpty, find } from "lodash";
import { mapGetters, mapActions } from "vuex";
import { format } from "date-fns";
import LocationApis from '@/Components/Controllers/LocationApis';
import Helpers from '@/Components/Helpers/Helpers';
import CartApis from '@/Components/Controllers/CartApis';

export default {
  components: {},
  name: "StoreLocation",
  data() {
    return {
      locationNearBy: [],
      markers: [
        {
          position: {
            lat: null,
            lng: null
          }
        }
      ],
      storeStatus: false,
      activeLocation: {},
      loaded: false,
    };
  },

  computed: {
    ...mapGetters({
      vg_selectedLocation: "location/selected",
     // locationNearBy: "location/nearby",
      vg_userAddress: "location/userAddress",
      vg_guestLandedQueries: "location/guestLandedQueries",
    })
  },

  watch: {
    'vg_userAddress': function() {
      LocationApis.fetchNearest(_.isEmpty(this.vg_userAddress) ? '' : this.vg_userAddress.geometry, false)
    },
  },

  async mounted() {
    document.getElementsByTagName("body")[0].setAttribute("id", "pg-location");
    // Fetch all locations 
    this.va_spinner(true);
    let res = await LocationApis.fetchNearest(_.isEmpty(this.vg_userAddress) ? '' : this.vg_userAddress.geometry, false);
    this.loaded = true;
    this.va_spinner(false);
    if(res.status == 200) {
       this.locationNearBy = res.data.payload;
      if(res.data.payload.length == 0){
        this.activeLocation = {};
      } else {
        // If we have already active location make it active
        if(_.isEmpty(this.vg_selectedLocation)){
          this.activeLocation = res.data.payload[0];
        } else {
          // Make the first one active by default 
          this.activeLocation = this.vg_selectedLocation;
        }
      }
    } else {
      this.activeLocation = {};
    }

    // Make the activeLcoation lat and lng active
    if(this.activeLocation && this.activeLocation.address && this.activeLocation.address.latitude && this.activeLocation.address.longitude){
      // just to prevent console 
      this.markers[0].position.lat = parseFloat(this.activeLocation.address.latitude);
      this.markers[0].position.lng = parseFloat(this.activeLocation.address.longitude);
    }
  },

  methods: {
    /**
     * Back to history
     */
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push({ name: 'HomePage', query: this.$route.query, });
    },

    // get opening and closing time for all the days of week
    getTodayOpenCloseTime(item) {
      let date = new Date();
      let today_date = format(date, "MMMM dd, yyyy ");
      // Get today item from weeks
      let todayItem = _.find(item.hours_of_operation, [
        "day_name",
        this.todayDayName()
      ]);

      if (!todayItem) return '--Unavailable--';

      // today's date + given opening time
      let today_open_time = new Date(today_date + todayItem.open_time);
      // today's date + given opening time
      let today_close_time = new Date(today_date + todayItem.close_time);

      // check if store is in between
      let start =
        parseInt(format(today_open_time, "HH")) * 60 +
        parseInt(format(today_open_time, "mm"));
      let end =
        parseInt(format(today_close_time, "HH")) * 60 +
        parseInt(format(today_close_time, "mm"));
      let current =
        parseInt(format(date, "HH")) * 60 + parseInt(format(date, "mm"));

      if (current >= start && current <= end) this.storeStatus = true;

      // return formatted opening and closing date
      return (
        format(today_open_time, "hh:mm aa") +
        " - " +
        format(today_close_time, "hh:mm aa")
      );
    },

    todayDayName() {
      let date = new Date();
      return format(date, "EEEE");
    },

    /**
     * Move to current selected store
     */
    
    async viewStore(item) {
      this.va_spinner(true);
      // Get the location details from slug, store it and go
      let location = await LocationApis.fetchBySlug(item.slug);
      this.va_spinner(false);
      if(location.status == 200 ){
      // set this store as current store
        await this.va_setSelectedLocation(location.data.payload);
        // now get cart of the location
       
        CartApis.locationCart(location.data.payload.id, Helpers.getLocationCartFullUrl(this));
     
        this.$router.push({
          name: 'StoreLanding',
          params: { 
            business_slug: this.$route.params.business_slug,
            store_slug: item.slug 
          },
          query: this.$route.query,
        });
      } else {
        this.va_snackbar({
          type: "warning",
          message: "Cannot find the store for this business."
        });
      }    
    },

    switchStore(item) {
      this.activeLocation = item;
      // switch marker for google map
      this.markers[0].position.lat = parseFloat(this.activeLocation.address.latitude);
      this.markers[0].position.lng = parseFloat(this.activeLocation.address.longitude);
    },

    /**
     * Get store fav image
     */
    getStorefeaturedImage(images) {
     return Helpers.getStoreFeaturedImage(images);
    },
    
    ...mapActions({
      va_setSelectedLocation: "location/setSelected",
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar"
    })
  }
};
</script>

<style scoped>
.store-item .store-logo img {
    width: 70px;
    height: auto;
}
.selected-location {
  width: 400px;
  max-width: 400px;
}
@media only screen and (max-width: 768px) {
  .map-section .map_canvas {
    height: 100%;
  }
  #pg-location .content-wrapper {
    min-height: 500px;
  }
}
</style>